<template>
   <base-section id="404">
   <v-card elevation="0" style="height: calc(100vh - 156px); align-content: center; display: grid;">
      <base-heading title="404" />
      <base-subheading space="8" title="NOT Found" />
   </v-card>
   </base-section>
</template>

<script>
export default {
   name: 'FourOhFour',

   provide: {
      heading: { align: 'center' },
   },
}
</script>
